import React from 'react';
import './CardFiscale.css';

const CardFiscale = (props) => {
    return (
        <div className='cardFiscale-container'>
            <div className='cardFiscale-illustration'>
              <img src= {props.illustration} alt="illustration" />
            </div>
            <h3 className='cardFiscale-title'>{props.title}</h3>
            {props.children}
        </div>
    )
};

export default CardFiscale;